












































































import { Component, Vue, Prop } from 'vue-property-decorator';
import CardView from '@/components/storage/storageList/directoryContents/views/CardView.vue';
import TableView from '@/components/storage/storageList/directoryContents/views/TableView.vue';
import ListView from '@/components/storage/storageList/directoryContents/views/ListView.vue';
import AddFolderModal from '@/components/storage/modals/AddFolderModal.vue';
import AddFileModal from '@/components/storage/modals/AddFileModal.vue';
import StorageSubHeader from '@/components/storage/storageList/storageSubHeader.vue';
import CommonButton from '@/components/common/CommonButton.vue';
import { vxm } from '@/store';

@Component({
  components: {
    CardView,
    TableView,
    ListView,
    AddFolderModal,
    AddFileModal,
    CommonButton,
    StorageSubHeader,
  },
})
export default class DirectoryContents extends Vue {
  public checkBoxArray: Array<number> = [];
  private view: string = 'card';
  private addFileButtonHeight: number = 30;
  private addFolderButtonHeight: number = 30;
  private isOpenAddFolderModal: boolean = false;
  private isOpenAddFileModal: boolean = false;
  private table = false;
  private list = false;
  private card = true;
  private addFileButtonElevation: string = '0';
  private addFileButtonColor: string = '#4384f3';
  private addFolderButtonElevation: string = '0';
  private addFolderButtonColor: string = '#4384f3';
  private isSearchBarFocus: boolean = false;
  private viewComponents: Array<typeof CardView | typeof ListView | typeof TableView> = [
    CardView,
    ListView,
    TableView,
  ];
  private viewComponentIndex: { card: number; list: number; table: number } = { card: 0, list: 1, table: 2 };
  private addModalComponents: { file: typeof AddFileModal; folder: typeof AddFolderModal } = {
    file: AddFileModal,
    folder: AddFolderModal,
  };
  private searchWord = '';

  private closeAddFileModal(): void {
    this.isOpenAddFileModal = false;
  }

  private closeAddFolderModal(): void {
    this.isOpenAddFolderModal = false;
  }

  private onChangeCardView(): void {
    this.view = 'card';
  }

  private onChangeListView(): void {
    this.view = 'list';
  }

  private onChangeTableView(): void {
    this.view = 'table';
  }

  private onChangeOpenAddFileModal(): void {
    this.isOpenAddFileModal = true;
  }

  private onChangeOpenAddFolderModal(): void {
    this.isOpenAddFolderModal = true;
  }

  private get directoryViewComponent(): typeof ListView | typeof CardView | typeof TableView | undefined {
    switch (this.view) {
      case 'card':
        return this.viewComponents[this.viewComponentIndex.card];
      case 'list':
        return this.viewComponents[this.viewComponentIndex.list];
      case 'table':
        return this.viewComponents[this.viewComponentIndex.table];
    }
  }

  private get addModalComponent(): typeof AddFileModal | typeof AddFolderModal {
    if (this.isOpenAddFileModal) {
      return this.addModalComponents.file;
    } else {
      return this.addModalComponents.folder;
    }
  }

  private get directories() {
    const response = vxm.theoryApi.directoriesStore.getCurrentDirectoryAndFiles;
    return response ? response.results.directories : [];
  }

  private get files() {
    const response = vxm.theoryApi.directoriesStore.getCurrentDirectoryAndFiles;
    return response ? response.results.files : [];
  }

  private get currentDirectoryName() {
    const response = vxm.theoryApi.directoriesStore.getCurrentDirectory;
    if (response) {
      return response.directoryName;
    } else return null;
  }

  private get currentDirectoryCreatedAt() {
    const response = vxm.theoryApi.directoriesStore.getCurrentDirectory;
    if (response) {
      return response.createdAt;
    } else return null;
  }

  private get existsCurrentDirectory() {
    const response = vxm.theoryApi.directoriesStore.getCurrentDirectory;
    if (response) {
      return true;
    } else return false;
  }
}
